export default __webpack_public_path__ + "static/media/returned.d9ddaf08.png";